<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_city_alarm"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >CITY OF RENO ALARM PROGRAM
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <v-card shaped>
          <v-card-title>
            <h4 class="howwrap">
              To register/renew your alarm online click on the link below:
            </h4>
          </v-card-title>
          <v-card-text>
            <div class="text-body2 text-sm-h6 text-md-h6">
              <a
                href="https://www.cityalarmpermit.us/Pages/Home.html?CityId=OzRDUvRMEbw="
                target="_blank"
                >CITY OF RENO ALARM PROGRAM</a
              >
            </div>
            <div
              class="mt-6"
              style="color: black; font-weight: 800; font-size: 1.25rem"
            >
              For questions regarding your invoices or false alarms please
              contact <a href="tel:8669509905">866-950-9905</a>.
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
.howwrap {
  word-break: break-word;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_city_alarm",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
